// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__wkaPQ","toggle__option":"Toggle_toggle__option__WtNgO","toggle__option--focused":"Toggle_toggle__option--focused__kvsph"};